import {Box, BoxProps, Typography} from '@mui/material';
import {AppButton, AppButtonProps} from 'components/buttons';
import {AppEllipsisTypographyProps} from 'components/typographies';
import {format} from 'date-fns';
import React from 'react';
export interface AppBaseCardHeaderProps extends Omit<BoxProps, 'children' | 'title'> {
    title: string | React.ReactNode;
    chipProps?: AppButtonProps;
    appEllipsisTypography?: AppEllipsisTypographyProps;
    dateTime?: string | Date;
}
export const AppBaseCardHeader: React.FC<AppBaseCardHeaderProps> = ({
    title,
    chipProps,
    appEllipsisTypography,
    dateTime,
    ...rest
}) => {
    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    marginBottom: '5px',
                    alignItems: 'center',
                }}
                {...rest}
            >
                {chipProps && (
                    <AppButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        sx={{
                            fontWeight: 500,
                            fontSize: '10px',
                            borderRadius: '8px',
                            textTransform: 'none',
                            px: 0.5,
                            py: 0.5,
                            minHeight: 'unset',
                            lineHeight: 1.0,
                            mr: 1,
                        }}
                        {...chipProps}
                    >
                        {chipProps.children}
                    </AppButton>
                )}

                {title}
            </Box>
            {dateTime && (
                <Typography mt={'-5px'} variant="subtitle2" color="text.secondary">
                    {dateTime ? format(new Date(dateTime), 'PPpp') : 'N/A'}
                </Typography>
            )}
        </Box>
    );
};

export default AppBaseCardHeader;
